import { useEffect } from 'react';
import { buildUniqueTickets } from '../helpers';

/**
 * Internal logic to merge existing tickets + possible tickets into uniqueTickets
 * possibleTickets: the list of all tickets that can be added
 * existingTickets: the RAW list of tickets from the DB
 * values: comes from Formik, the current data
 * setFieldValue: comes from Formik, to set values
 */
export function InternalTicketMergingLogic({
    possibleTickets,
    existingTickets,
    values,
    setFieldValue
}) {
    // trick to ignore most of the values changes
    const ticketKeyaQuantityString = JSON.stringify(
        (values?.uniqueTickets || []).map(u => ({ key: u.key, quantity: u.quantity }))
    );

    useEffect(() => {
        if (!possibleTickets || !existingTickets || !ticketKeyaQuantityString) {
            return;
        }
        const liteUniqueTickets = JSON.parse(ticketKeyaQuantityString);
        /**
         * {
    "possibleTickets": [
        {
            "id": 1236,
            "name": "Premium adult ticket",
            "retail_price": 50,
            "agentCommission": 5,
            "finalPrice": 54.81,
            "price_items": [...]
        },
    ],
    "existingTickets": [
        {
            "booking_item_ticket_id": 899,
            "ticket_id": 1236,
            "discount_id": null,
            "name": "Premium adult ticket",
            "quantity": 3,
            "retail_price": 50,
            "taxes_and_fees": 14.43,
            "created_at": "2025-09-26T13:50:07.000Z"
        },
    ]
}
         */

        setFieldValue(
            'uniqueTickets',
            buildUniqueTickets(existingTickets, possibleTickets, liteUniqueTickets)
        );
    }, [possibleTickets, existingTickets, setFieldValue, ticketKeyaQuantityString]);

    return null;
}
